import { Edit, translate } from "react-admin";
import React from "react";

import BillForm from "./BillForm";

const BillTitle = ({ translate, record }) => {
  return (
    <span>
      {`แก้ไขบิล`}
    </span>
  );
};

const Title = translate(BillTitle);

export const BillEdit = props => (
  <Edit title={<Title />} {...props}>
    <BillForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/bill/BillEdit.js